import { ofType } from 'redux-observable';
import { map, mergeMap } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { throttleUntilChanged } from '../../utils/rxjs-utils';
import * as actionType from '../../store/state/actions';
import { ActionManagerInstance } from '../../actions/manager';
import * as actions from '../../store/state/actions/action-creators';
import * as StateManager from '../../store/state/state-manager';
import { getResolvedTargetName } from '../../router/routing-manager';
import { isErrorActionType } from '../../case/common-helper';
import {
  processDataToDispatchErrorAction,
  getContext,
  processViewResponse,
  getActionPayload
} from '../../store/state/epics/util';
import { publicConstants } from '../../constants';
import type { Action } from '../../store/state/state-manager';

import executeGetDataObjectViewRequest from './async-request';
import { getDataObjectViewAction } from './action-creator';

const getDataObjectView = (action$: Observable<Action>) => {
  let actionMgrID = 0;
  let actionsOut: any[] = [];

  return action$.pipe(
    ofType(actionType.VIEW_DATA_OBJECT),
    throttleUntilChanged(100),
    map((action: Action) => {
      ({ actionMgrID } = action.payload);
      return action.payload;
    }),
    mergeMap((payload) => {
      return executeGetDataObjectViewRequest(payload);
    }),
    mergeMap(async (data: any) => {
      if (data && data.type === actionType.ERROR) {
        const { payload } = data;
        const errorAction = processDataToDispatchErrorAction({ ...data, ...payload, actionMgrID });
        actionsOut.push(errorAction);
        return actionsOut;
      }
      const { actionInPayload, response, headers = {} } = data;
      const { containerName, readOnly, actionName } = actionInPayload;
      const target = getResolvedTargetName(containerName, actionInPayload.context);
      const context = getContext(target, containerName, actionInPayload.context);
      const options = { acName: target, context };

      if (response?.data?.dataInfo) {
        const { dataInfo } = response.data;
        dataInfo.dataContext ||= actionInPayload.dataLookUp;
        dataInfo.dataContextParameters ||= actionInPayload.requestPayload;
      }

      await processViewResponse(response, actionInPayload, options);

      const commonInfo = {
        target,
        context,
        containerItemID: context,
        headers
      };

      const payload = getActionPayload(response, commonInfo);
      payload.resourceType = publicConstants.RESOURCE_TYPES.DATA;
      payload.resourceStatus = publicConstants.RESOURCE_STATUS.UPDATE;
      payload.readOnly = readOnly;
      payload.actionName = actionName;
      payload.key = JSON.stringify(actionInPayload.requestPayload);
      actionsOut.push(actions.postProcess(actions.addContainerItem, payload));
      return actionsOut;
    }),
    map(() => {
      if (actionsOut.length === 1 && isErrorActionType(actionsOut[0].type)) {
        ActionManagerInstance.rejectActionByID(actionMgrID);
      } else {
        ActionManagerInstance.resolveActionByID(actionMgrID);
      }
      StateManager.dispatch(actionsOut);
      actionsOut = [];
      return actionsOut;
    })
  );
};

export { getDataObjectView, getDataObjectViewAction };
